import { c as _c } from "react/compiler-runtime";
import { Dropdown, DropdownButton, DropdownDivider, DropdownItem, DropdownMenu } from "@/components/ui/dropdown";
import { EllipsisVerticalIcon } from "@heroicons/react/16/solid";
import { useThemeStore } from "@/store/theme-store";
import { useState } from "react";
import { Alert, AlertActions, AlertDescription, AlertTitle } from "../ui/alert";
import { Button } from "../ui/button";
export const ColorPickerOptions = t0 => {
  const $ = _c(7);
  const {
    colorKey
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DropdownButton className="group/options !absolute top-0 right-0 rounded-none data-focus:inset-ring-2 data-focus:inset-ring-blue-500" plain={true}><EllipsisVerticalIcon className="text-border mt-2 size-4 opacity-35" /><span className="sr-only">Options</span></DropdownButton>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== colorKey) {
    t2 = <ResetButton colorKey={colorKey} />;
    $[1] = colorKey;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DropdownDivider />;
    t4 = <ResetAllButton />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2) {
    t5 = <Dropdown>{t1}<DropdownMenu anchor="bottom end">{t2}{t3}{t4}</DropdownMenu></Dropdown>;
    $[5] = t2;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
const ResetButton = t0 => {
  const $ = _c(6);
  const {
    colorKey
  } = t0;
  const reset = useThemeStore(_temp);
  let t1;
  if ($[0] !== colorKey || $[1] !== reset) {
    t1 = () => reset(colorKey);
    $[0] = colorKey;
    $[1] = reset;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== colorKey || $[4] !== t1) {
    t2 = <DropdownItem onClick={t1}>Reset {colorKey}</DropdownItem>;
    $[3] = colorKey;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
const ResetAllButton = () => {
  const $ = _c(4);
  const [isOpen, setIsOpen] = useState(false);
  const resetAll = useThemeStore(_temp2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = e => {
      e.preventDefault();
      setIsOpen(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isOpen || $[2] !== resetAll) {
    t1 = <><DropdownItem variant="destructive" onClick={t0}>{t2 => {
          const {
            close
          } = t2;
          return <>Reset all...<Alert open={isOpen} onClose={() => {
              setIsOpen(false);
              close();
            }}><AlertTitle>Are you sure you want to reset all colors?</AlertTitle><AlertDescription>Reset all colors in all platforms to the default values.</AlertDescription><AlertActions><Button plain={true} onClick={() => {
                  setIsOpen(false);
                  close();
                }}>Cancel</Button><Button color="red" onClick={() => {
                  resetAll();
                  setIsOpen(false);
                  close();
                }}>Reset All</Button></AlertActions></Alert></>;
        }}</DropdownItem></>;
    $[1] = isOpen;
    $[2] = resetAll;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(state) {
  return state.reset;
}
function _temp2(state) {
  return state.resetAll;
}